// extracted by mini-css-extract-plugin
export default {"menu":"Desktopmenu_menu__xuL5q","link":"Desktopmenu_link__qxMp7 utils_link__VFwWm","underline":"Desktopmenu_underline__q7IW8 utils_underline__yiC6B"};